<template>
  <v-card flat class="picker">
    <v-card-title class="d-flex justify-space-between pa-1 ma-0 picker-header">
      <v-btn @click="controlButton(-12)" icon :disabled="years[0] <= 1950"
        ><v-icon>chevron_left</v-icon></v-btn
      >
      <span class="a-title dark--text a-bold"> {{ dateText }} </span>

      <v-btn
        @click="controlButton(12)"
        icon
        :disabled="atualYear == years[years.length - 1]"
        ><v-icon>chevron_right </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="picker-text pa-0 ma-0">
      <v-btn
        v-for="year in years"
        :key="year"
        :class="['picker-button', handleColor(year) ? 'white--text' : '']"
        :color="handleColor(year) || year == atualYear ? color : 'white'"
        :disabled="handleMaxMin(year)"
        depressed
        @click="handleClick(year)"
        :outlined="year == atualYear && !handleColor(year)"
      >
        {{ year }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  props: {
    range: { type: Boolean, default: false },
    color: { type: String, default: "green lighten-1" },
    max: { type: String, default: 1900 },
    min: { type: String, default: 2100 },
    initialDate: [String, Array],
  },
  data() {
    return {
      years: [],
      selectedYears: [],
      dateText: moment().format("YYYY"),
      atualYear: Number(moment().format("YYYY")),
      controlYear: Number(moment().format("YYYY")),
      date: [],
    };
  },
  created() {
    this.setInitialDate();
    this.generateYears();
  },
  watch: {
    date: {
      handler() {
        this.$emit("input", this.date);
      },
      immediate: true,
      deep: true,
    },
    initialDate: {
      handler() {
        this.setInitialDate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    generateYears() {
      this.years = [];
      for (
        let initialYear = this.controlYear - 11;
        initialYear <= this.controlYear;
        initialYear++
      ) {
        this.years.push(initialYear);
      }
    },
    setInitialDate() {
      if (!this.initialDate) {
        this.selectedYears.push(Number(this.atualYear));
        return;
      } else {
        this.date = this.initialDate;
        const start = this.initialDate[0].substring(0, 4);
        const end = this.initialDate[1].substring(0, 4);
        this.selectedYears.push(start);
        if (start != end) this.selectedYears.push(end);
      }
      this.setDate();
    },
    handleClick(year) {
      if (this.range && this.selectedYears.length == 1) {
        let smallerYear = this.selectedYears[0];
        let biggerYear = year;

        const whoIsBigger = this.selectedYears[0] - year;

        if (whoIsBigger > 0) {
          smallerYear = year;
          biggerYear = this.selectedYears[0];
        }
        let years = [];
        for (let index = smallerYear; index <= biggerYear; index++) {
          years.push(index);
        }
        this.selectedYears = years;
      } else {
        this.selectedYears = [];
        this.selectedYears.push(year);
      }
      this.setDate();
    },
    setDate() {
      if (this.selectedYears.length != 1) {
        const initialYear = `${this.selectedYears[0]}`;
        const lastYear = `${this.selectedYears[this.selectedYears.length - 1]}`;
        this.date = [initialYear, lastYear];
        this.dateText = `${initialYear}-${lastYear}`;
      } else {
        this.dateText = `${this.selectedYears[0]}`;
        this.date = [`${this.selectedYears[0]}`];
      }
    },
    handleColor(year) {
      const finded = this.selectedYears.find((e) => e == year);
      return finded;
    },
    handleMaxMin(year) {
      if (this.selectedYears.length !== 1 || !this.range) return false;
      return !(year <= Number(this.max) && year >= Number(this.min));
    },
    controlButton(value) {
      this.controlYear += value;
      this.generateYears();
    },
  },
};
</script>

<style scoped>
.picker {
  height: 290px;
  width: 290px;
  padding: 0px 12px;
}
.picker-header {
  height: 48px;
}
.picker-button {
  height: 36px;
  width: 86px;
  padding: 0px 16px;
  margin-right: 2px;
  margin-bottom: 22px;
}
.picker-button-white {
  color: white !important;
}
.picker-text {
  padding: 0px 12px 0px 14px;
}
</style>